import React from 'react'
import logo from '../../../assets/icon.png'
import styles from './NavBar.module.css'
import { Icon } from "@iconify/react";

function NavBar(props){

    const { onToggleModal: openModalHandler } = props

    return (
        <div className={styles['navbar']}>
            <Icon className={styles['navbar-icon']} onClick={openModalHandler} icon="heroicons-outline:menu-alt-1" width="24" height="24" style={{color: '#FFFFFF'}}/>
            <img alt={'Logo'} src={logo} className={styles['navbar-logo']}/>
            <span></span>
            {/*<Icon icon="circum:user" style={{color: '#FFFFFF'}}/>*/}
        </div>
    )
}

export default NavBar